<div class="bridges-board">
  <!-- Announces the result of keyboard moves; visually hidden, not display:none -->
  <p class="bridges-live-region" aria-live="polite" role="status">{{ announcement }}</p>

  <svg
    [attr.viewBox]="'0 0 ' + widthPX + ' ' + heightPX"
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    role="group"
    [attr.aria-label]="boardLabel"
  >
    <defs>
      <linearGradient id="bridges-water" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" class="bridges-water-top" />
        <stop offset="1" class="bridges-water-bottom" />
      </linearGradient>
      <pattern
        id="bridges-lattice"
        [attr.width]="cellSize"
        [attr.height]="cellSize"
        [attr.x]="boardPadding"
        [attr.y]="boardPadding"
        patternUnits="userSpaceOnUse"
      >
        <circle cx="0" cy="0" r="1.5" class="bridges-lattice-dot" />
      </pattern>
    </defs>

    <!-- Board surface: sized to the viewBox so it hugs the board, not the letterboxed container -->
    <rect x="0" y="0" [attr.width]="widthPX" [attr.height]="heightPX" rx="16" class="bridges-surface" />
    <rect x="0" y="0" [attr.width]="widthPX" [attr.height]="heightPX" rx="16" fill="url(#bridges-lattice)" />

    <g class="bridges">
      <g
        *ngFor="let b of bridgeVms; trackBy: trackBridge"
        class="bridge-group"
        (click)="cycleBridge(b.key)"
        (mouseenter)="enterBridge(b.key)"
        (mouseleave)="leaveBridge()"
      >
        <!-- Invisible hit area so the whole span between islands is clickable -->
        <line
          [attr.x1]="b.hit.x1"
          [attr.y1]="b.hit.y1"
          [attr.x2]="b.hit.x2"
          [attr.y2]="b.hit.y2"
          [attr.stroke-width]="hitStrokeWidth"
          class="bridge-hit"
        />
        <!-- Both rails are always rendered, committed or not: a standing element
             can slide aside and cross-fade, where one that is created and
             destroyed can only pop in and out under the pointer. -->
        <line
          *ngFor="let r of b.rails; trackBy: trackRail"
          [attr.x1]="b.base.x1"
          [attr.y1]="b.base.y1"
          [attr.x2]="b.base.x2"
          [attr.y2]="b.base.y2"
          [attr.stroke-width]="bridgeStroke"
          [attr.stroke-linecap]="r.committed ? 'round' : 'butt'"
          [attr.pathLength]="r.committed ? 1 : null"
          [style.stroke-dasharray]="r.committed ? null : previewDash"
          [style.transform]="r.transform"
          class="bridge-rail"
          [class.is-committed]="r.committed"
          [class.is-visible]="r.visible"
          [class.is-removing]="r.removing"
        />
      </g>
    </g>

    <g class="nodes">
      <g
        *ngFor="let n of islandVms; trackBy: trackIsland"
        class="island-group"
        tabindex="0"
        role="button"
        [attr.aria-label]="n.ariaLabel"
        [attr.aria-describedby]="'bridges-island-hint'"
        (keydown)="onIslandKeydown($event, n)"
        (mousedown)="mouseDownIsland(n.island)"
        (mouseup)="mouseUpIsland(n.island)"
        (touchstart)="touchStartIsland($event, n.island)"
        (mouseenter)="enterIsland(n.island)"
        (mouseleave)="leaveIsland()"
        (click)="$event.stopPropagation()"
      >
        <circle *ngIf="n.active" [attr.cx]="n.cx" [attr.cy]="n.cy" [attr.r]="n.ringRadius" class="island-ring" />

        <!-- Invisible, larger touch target for small screens -->
        <circle [attr.cx]="n.cx" [attr.cy]="n.cy" [attr.r]="n.tapRadius" class="island-tap" />

        <circle
          [attr.cx]="n.cx"
          [attr.cy]="n.cy"
          [attr.r]="islandRadius"
          class="island"
          [class.is-done]="n.mark === 'satisfied'"
          [class.is-confirmed]="n.mark === 'confirmed'"
          [class.is-over]="n.mark === 'violation' || n.mark === 'deviates'"
        />
        <text
          [attr.x]="n.cx"
          [attr.y]="n.cy"
          text-anchor="middle"
          dominant-baseline="central"
          [attr.font-size]="islandFontSize"
          class="island-label"
          [class.is-done]="n.mark === 'satisfied'"
          [class.is-confirmed]="n.mark === 'confirmed'"
          [class.is-over]="n.mark === 'violation' || n.mark === 'deviates'"
        >
          {{ n.label }}
        </text>

        <!-- The cross means a rule is broken, so it is drawn only for `violation`.
             A `deviates` island breaks nothing — it is red on its own. -->
        <ng-container *ngIf="n.mark === 'violation'">
          <line
            [attr.x1]="n.crossA.x1"
            [attr.y1]="n.crossA.y1"
            [attr.x2]="n.crossA.x2"
            [attr.y2]="n.crossA.y2"
            stroke-width="3"
            stroke-linecap="round"
            class="island-error-cross"
          />
          <line
            [attr.x1]="n.crossB.x1"
            [attr.y1]="n.crossB.y1"
            [attr.x2]="n.crossB.x2"
            [attr.y2]="n.crossB.y2"
            stroke-width="3"
            stroke-linecap="round"
            class="island-error-cross"
          />
        </ng-container>

        <circle
          *ngIf="n.checkError"
          [attr.cx]="n.cx"
          [attr.cy]="n.cy"
          [attr.r]="n.ringRadius"
          stroke-width="4"
          class="island-check-error"
        />
      </g>
    </g>
  </svg>

  <p id="bridges-island-hint" class="bridges-live-region">{{ 'BRIDGES.a11y.island_hint' | translate }}</p>
</div>
